// Configuration du produit « PDF Fit by Daya » (partagée client + serveur)
export const PDF_PRODUCT = {
  id: "pdf-fitbydaya-2026", // ne pas changer : sert à vérifier les achats déjà faits
  name: "Fit by Daya — Programme fitness 60 jours",
  description: "Affiner, tonifier & briller : planning 60 jours, séances détaillées, exercices expliqués et suivi de progression.",
  amount: 2200, // en centimes → 22,00 €
  currency: "eur",
  priceLabel: "22€",
  // Fichier servi après paiement, rangé HORS de public/ pour ne pas être accessible directement
  file: "private/guide-fit-by-daya.pdf",
  downloadName: "Fit-by-Daya-Programme-60-jours.pdf",
}
